var React = require('react');

function IconChevronUp (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M12 7.5l7.5 7.5-1.05 1.05L12 9.6l-6.45 6.45L4.5 15 12 7.5z"}));
}

IconChevronUp.defaultProps = {"fill":"currentColor","aria-hidden":"true","focusable":"false","viewBox":"0 0 24 24"};

module.exports = IconChevronUp;

IconChevronUp.default = IconChevronUp;
